import { useState } from "react";
import { ImageField, ImageInput } from "react-admin";
import { useFormContext } from "react-hook-form";

const UploadImage = ({ name, label, record }) => {
  const form = useFormContext();
  const [imageUrl, setImageUrl] = useState("");
  const upload = async (e) => {
    var formData = new FormData();
    formData.append("image", e);
    const reponse = await fetch(
      `https://api.mahsool.sd` + "/image/upload",
      // `http://localhost:3060` + "/image/upload",
      {
        method: "POST",
        body: formData,
      }
    ).then((res) => res.json());
    setImageUrl(reponse.url);
    form.setValue(
      `${name}`,
      record ? [...record.images, reponse.url] : reponse.url
    );
  };
  //
  return (
    <>
      {/* {imageUrl ? "" : <ImageField source="image"  className="w-40" />} */}

      <ImageInput
        source={`_image`}
        onChange={(e) => upload(e)}
        multiple={false}
      >
        {/* {imageUrl ?: <ImageField source="image" /> } */}
        <img src={imageUrl} alt="" className="w-[40rem]" />
      </ImageInput>
    </>
  );
};

export default UploadImage;
